export const SET_OFFRES_SALARIALES_LOADING = "SET_OFFRES_SALARIALES_LOADING";
export const SET_OFFRES_SALARIALES_ERROR = "SET_OFFRES_SALARIALES_ERROR";

export const FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_REQUEST = "FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_REQUEST";
export const FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_SUCCESS = "FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_SUCCESS";
export const FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_FAIL = "FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_FAIL";

export const CREATE_OFFRE_SALARIALE_REQUEST = "CREATE_OFFRE_SALARIALE_REQUEST";
export const CREATE_OFFRE_SALARIALE_SUCCESS = "CREATE_OFFRE_SALARIALE_SUCCESS";
export const CREATE_OFFRE_SALARIALE_FAIL = "CREATE_OFFRE_SALARIALE_FAIL";

export const UPDATE_OFFRE_SALARIALE_REQUEST = "UPDATE_OFFRE_SALARIALE_REQUEST";
export const UPDATE_OFFRE_SALARIALE_SUCCESS = "UPDATE_OFFRE_SALARIALE_SUCCESS";
export const UPDATE_OFFRE_SALARIALE_FAIL = "UPDATE_OFFRE_SALARIALE_FAIL";

export const DELETE_OFFRE_SALARIALE_REQUEST = "DELETE_OFFRE_SALARIALE_REQUEST";
export const DELETE_OFFRE_SALARIALE_SUCCESS = "DELETE_OFFRE_SALARIALE_SUCCESS";
export const DELETE_OFFRE_SALARIALE_FAIL = "DELETE_OFFRE_SALARIALE_FAIL";

export const DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_REQUEST = "DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_REQUEST";
export const DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_SUCCESS = "DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_SUCCESS";
export const DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_FAIL = "DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_FAIL";

export const SEND_OFFRE_SALARIALE_EMAIL_REQUEST = "SEND_OFFRE_SALARIALE_EMAIL_REQUEST";
export const SEND_OFFRE_SALARIALE_EMAIL_SUCCESS = "SEND_OFFRE_SALARIALE_EMAIL_SUCCESS";
export const SEND_OFFRE_SALARIALE_EMAIL_FAIL = "SEND_OFFRE_SALARIALE_EMAIL_FAIL";

export const setOffresSalarialesLoading = (v) => ({
    type: SET_OFFRES_SALARIALES_LOADING,
    payload: v,
});

export const setOffresSalarialesError = (msg) => ({
    type: SET_OFFRES_SALARIALES_ERROR,
    payload: msg,
});

export const fetchOffreSalarialeByCandidatureRequest = (candidatureId) => ({
    type: FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_REQUEST,
    payload: { candidatureId },
});

export const fetchOffreSalarialeByCandidatureSuccess = (data) => ({
    type: FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_SUCCESS,
    payload: data,
});

export const fetchOffreSalarialeByCandidatureFail = (err) => ({
    type: FETCH_OFFRE_SALARIALE_BY_CANDIDATURE_FAIL,
    payload: err,
});

export const createOffreSalarialeRequest = (payload) => ({
    type: CREATE_OFFRE_SALARIALE_REQUEST,
    payload,
});

export const createOffreSalarialeSuccess = (data) => ({
    type: CREATE_OFFRE_SALARIALE_SUCCESS,
    payload: data,
});

export const createOffreSalarialeFail = (err) => ({
    type: CREATE_OFFRE_SALARIALE_FAIL,
    payload: err,
});

export const updateOffreSalarialeRequest = (id, payload) => ({
    type: UPDATE_OFFRE_SALARIALE_REQUEST,
    payload: { id, payload },
});

export const updateOffreSalarialeSuccess = (data) => ({
    type: UPDATE_OFFRE_SALARIALE_SUCCESS,
    payload: data,
});

export const updateOffreSalarialeFail = (err) => ({
    type: UPDATE_OFFRE_SALARIALE_FAIL,
    payload: err,
});

export const deleteOffreSalarialeRequest = (id, candidatureId = null) => ({
    type: DELETE_OFFRE_SALARIALE_REQUEST,
    payload: { id, candidatureId },
});

export const deleteOffreSalarialeSuccess = (payload) => ({
    type: DELETE_OFFRE_SALARIALE_SUCCESS,
    payload,
});

export const deleteOffreSalarialeFail = (err) => ({
    type: DELETE_OFFRE_SALARIALE_FAIL,
    payload: err,
});

export const downloadOffreSalarialeDocumentRequest = (id) => ({
    type: DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_REQUEST,
    payload: { id },
});

export const downloadOffreSalarialeDocumentSuccess = () => ({
    type: DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_SUCCESS,
});

export const downloadOffreSalarialeDocumentFail = (err) => ({
    type: DOWNLOAD_OFFRE_SALARIALE_DOCUMENT_FAIL,
    payload: err,
});

export const sendOffreSalarialeEmailRequest = (id) => ({
    type: SEND_OFFRE_SALARIALE_EMAIL_REQUEST,
    payload: { id },
});

export const sendOffreSalarialeEmailSuccess = (data) => ({
    type: SEND_OFFRE_SALARIALE_EMAIL_SUCCESS,
    payload: data,
});

export const sendOffreSalarialeEmailFail = (err) => ({
    type: SEND_OFFRE_SALARIALE_EMAIL_FAIL,
    payload: err,
});
